import { Search } from "@material-ui/icons";
import kendo from "@progress/kendo-ui";
import { numFormat, roundNum } from "../../com/dataUtil";
import { getToken } from "../authService";

export const getUserListData = async (conn, param, callback, reject) => {
  await conn
    .get("user/area/list", {
      params: {
        rgnCode: param.rgnCode,
        dongCode: param.dongCode,
      }
    })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      reject(error);
    });
};

export const getGridData = async (conn, callback, reject, param, page) => {
  await conn
    .get("data/raw/page", {
      params: {
        dongCode: param.dongCode,
        userId: param.userId,
        startDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
        endDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
        page: page.skip / page.take + 1,
        size: page.take,
      },
    })
    .then(response => {
      const result = response;
      result.results.forEach(element => {
        element.gathDtm = element.gathDtm.replace("T", " ");
        element.breathCnt = element.breathCnt !== null ? element.breathCnt : "-";
        element.movement = element.movement !== null ? numFormat(element.movement) : "-";
        element.movementPure = element.movementPure !== null ? numFormat(element.movementPure) : "-";
        element.movementTotal = element.movementTotal !== null ? numFormat(element.movementTotal) : "-";
        element.velocity = element.velocity !== null ? numFormat(element.velocity) : "-";
        element.velocityTotal = element.velocityTotal !== null ? numFormat(element.velocityTotal) : "-";
        element.temperature = element.temperature !== null ? roundNum(element.temperature, 2) : "-";
        element.humidity = element.humidity !== null ? roundNum(element.humidity, 2) : "-";
        element.waveSignal = element.waveSignal !== null ? element.waveSignal : "-";
        element.eventType = element.eventType !== null ? element.eventType : "-";
        element.light = element.light !== null ? element.light : "-";
        element.co2 = element.co2 !== null ? element.co2 : "-";
        element.tvoc = element.tvoc !== null ? element.tvoc : "-";
      });
      callback(result);
    })
    .catch(error => {
      reject(error);
    });
};

export const getRawChart = async (conn, data) => {
  const { userId, startDtm, endDtm } = data;
  const config = {
    params: {
      userId: userId,
      startDtm: kendo.toString(startDtm, "yyyy-MM-dd"),
      endDtm: kendo.toString(startDtm, "yyyy-MM-dd"),
    }
  }

  const response = await conn.get("data/raw/chart", config);

  response.forEach(item => {
    if(item.bizType === "5003") {
      item.temperature -= 5;
      item.humidity += 10;
    }
    if(item.bizType === "5002") {
      item.co2 = null;
      item.tvoc = null;
    }
  })

  const gathDtm = response.map(obj => obj.gathDtm);
  const movementData = response.map(obj => obj.movement);
  const movementPureData = response.map(obj => obj.movementPure);
  const movementTotalData = response.map(obj => obj.movementTotal);
  const velocityData = response.map(obj => obj.velocity);
  const velocityTotalData = response.map(obj => obj.velocityTotal);
  const temperatureData = response.map(obj => obj.temperature);
  const humidityData = response.map(obj => obj.humidity);
  const co2Data = response.map(obj => obj.co2);
  const tvocData = response.map(obj => obj.tvoc);
  const lightData = response.map(obj => obj.light);
  const dataStatSctCodeValData = response.map(obj => obj.dataStatSctCodeVal);

  const meainStatCodeData = response.map(obj => obj.meainStatCode);
  const transformedData = meainStatCodeData.map((element) => {
    if (element === null) {
      return 0;
    } else if (element === 20001) {
      return 1;
    } else if (element === 20002) {
      return 2;
    } else if (element === 20003) {
      return 3;
    } else if (element === 20004) {
      return 4;
    } else if (element === 20005) {
      return 5;
    } else {
      return 6;
    }
  })
  const meainStatTermData = response.map(obj => obj.meainStatTerm);
  const meainStatTermCustomData = gathDtm.map((item, index) => ({
    gathDtm: gathDtm[index],
    meainStatTerm: meainStatTermData[index],
  }));
  const result = {
    gathDtm: gathDtm,
    movementData: movementData,
    movementPureData: movementPureData,
    movementTotalData: movementTotalData,
    velocityData: velocityData,
    velocityTotalData: velocityTotalData,
    temperatureData: temperatureData,
    humidityData: humidityData,
    co2Data: co2Data,
    tvocData: tvocData,
    lightData: lightData,
    meainStatCodeData: transformedData,
    meainStatTermData: meainStatTermCustomData,
    dataStatSctCodeValData: dataStatSctCodeValData,
  }

  return result;
};

export const getChartData = async (conn, callback, reject, param) => {
  await conn
    .get("data/userStat/list", {
      params: {
        dongCode: param.dongCode,
        userId: param.userId,
        dateType: param.radio,
        startDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
        endDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
      },
    })
    .then(response => {

      const result = response;
      // 움직임/호흡 / Co2 추이
      const movementDs = [];
      const breathCntDs = [];
      const co2Ds = [];
      // 온/습도/조도 추이
      const temperatureDs = [];
      const humidityDs = [];
      const lightDs = [];

      // 이벤트 추이
      const highActivityCntDs = [];
      const lowActivityCntDs = [];
      const sleepCntDs = [];
      const deepSleepCntDs = [];
      const eatCntDs = [];
      const noneCntDs = [];

      result.forEach(element => {
        const gathDtm = param.radio === "HH" ? element.gathDtm : element.gathDtm;
        movementDs.push({ name: gathDtm, y: element.movement });
        breathCntDs.push({ name: gathDtm, y: element.breathCnt });
        temperatureDs.push({ name: gathDtm, y: element.temperature });
        humidityDs.push({ name: gathDtm, y: element.humidity });
        lightDs.push({ name: gathDtm, y: element.light ? element.light : 0 });
        highActivityCntDs.push({ name: gathDtm, y: element.highActivityCnt });
        lowActivityCntDs.push({ name: gathDtm, y: element.lowActivityCnt });
        sleepCntDs.push({ name: gathDtm, y: element.sleepCnt });
        deepSleepCntDs.push({ name: gathDtm, y: element.deepSleepCnt });
        eatCntDs.push({ name: gathDtm, y: element.eatCnt });
        noneCntDs.push({ name: gathDtm, y: element.noneCnt });
        co2Ds.push({ name: gathDtm, y: element.co2 ? element.co2 : 0 });
      });

      // 결과
      const resultChartDs = {
        movementDs: movementDs,
        breathCntDs: breathCntDs,
        temperatureDs: temperatureDs,
        humidityDs: humidityDs,
        lightDs: lightDs,
        highActivityCntDs: highActivityCntDs,
        lowActivityCntDs: lowActivityCntDs,
        sleepCntDs: sleepCntDs,
        deepSleepCntDs: deepSleepCntDs,
        eatCntDs: eatCntDs,
        noneCntDs: noneCntDs,
        co2Ds: co2Ds,
      };
      callback(resultChartDs);
    })
    .catch(error => {
      reject(error);
    });
};

export const gathDataExcelDownLoad = (param, loading) => {
  loading(true);
  const token = getToken();
  const url = "/api/v2.2/data";
  const excelTitle = param.userTerm + "_데이터 수집현황_" + kendo.toString(new Date(), "yyyy-MM-dd") + ".xlsx";
  downloadExcel(param, excelTitle, url, token, loading);
};

const downloadExcel = (data, fileName, url, token, loading) => {
  const request = new XMLHttpRequest();
  request.open("POST", url + "/excelDownload", true);
  request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
  request.setRequestHeader("X-AUTH-TOKEN", token);
  request.setRequestHeader("Accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  request.responseType = "blob";
  request.onload = function (e) {
    if (this.status === 200) {
      const blob = this.response;
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, fileName);
      } else {
        const downloadLink = window.document.createElement("a");
        const contentTypeHeader = request.getResponseHeader("Content-Type");
        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
      // clearInterval(progress);
      // excelUploadProgressClear(url+"/excelDownloadProgressClear");
    } else {
      // clearInterval(progress);
      // excelUploadProgressClear(url+"/excelDownloadProgressClear");
    }
  };
  if (loading) {
    loading(false);
  }
  request.send(JSON.stringify(data));
  return request;
};

export const getRawAvgData = async (conn, callback, reject, param) => {
  await conn
    .get("data/raw/avg", {
      params: {
        userId: param.userId,
        startDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
        endDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
      },
    })
    .then(response => {
      const result = response[0];
      
      let movement = result.movement;
      let temperature = result.temperature;
      let humidity = result.humidity;
      let co2 = result.co2;
      let light = result.light;

      const recentData = {
        movement: movement,
        temperature: temperature,
        humidity: humidity,
        co2: co2,
        light: light
      }
      
      callback(recentData);
    })
    .catch(error => {
      reject(error);
    });
};

export const getRawRecentData = async (conn, callback, reject, param) => {
  await conn
    .get("data/raw/recent", {
      params: {
        userId: param.userId,
        startDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
        endDtm: kendo.toString(param.startDtm, "yyyy-MM-dd"),
      },
    })
    .then(response => {
      const result = response[0];
      
      let movement = result.movement;
      let temperature = result.temperature;
      let humidity = result.humidity;
      let co2 = result.co2;
      let light = result.light;

      const recentData = {
        movement: movement,
        temperature: temperature,
        humidity: humidity,
        co2: co2,
        light: light
      }

      callback(recentData);
    })
    .catch(error => {
      reject(error);
    });
};
